<template>
  <div class="categoryBody">
    <div class="cateboryItem" v-for="cate in cates" @click="goToCid(cate)">
      <div class="itemHead"><img :src="cdn+cate.path"/></div>
      <div class="itemFoot"><span>{{cate.title}}</span></div>
    </div>
    <div style="clear: both"></div>
  </div>
</template>
<script>
  export default{
    name:'category',
    props:['cates','cdn'],
    data(){
      return {
      }
    },
    created(){

    },
    mounted(){

    },
    watch:{

    },
    methods:{
      goToCid(cate){
        this.jumpToView(this.headType.cidHead,"t="+cate.key,cate.key);
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Category.vue?3059d3ce